// Resolve the active white-label payload from boot or website context.
// Falls back to fetching it from the public API for early/portal pages.
export function getConfig() {
	if (typeof frappe !== "undefined" && frappe.boot && frappe.boot.white_label) {
		return frappe.boot.white_label;
	}
	if (typeof window !== "undefined" && window.white_label) {
		return window.white_label;
	}
	return { enabled: false };
}

export function getCurrentAppName() {
	// Best-effort detection of "which app the user is currently inside".
	// Used to apply per-app branding overrides on top of the global ones.
	try {
		const route = (frappe.get_route && frappe.get_route()) || [];
		if (route[0] === "modules" && route[1]) return route[1].toLowerCase();
		if (route[0] === "Workspaces" && route[1]) return route[1].toLowerCase();
		if (frappe.boot && frappe.boot.current_app) return frappe.boot.current_app;
	} catch (e) {
		// ignore
	}
	return null;
}

export function getMergedTextReplacements(config) {
	const rules = [];
	const policy = config.text_policy || {};
	if (!policy.enabled) return rules;
	(policy.replacements || []).forEach((r) => rules.push(r));

	const appCfg = (config.apps || {})[getCurrentAppName()];
	if (appCfg && appCfg.is_active) {
		(appCfg.text_replacements || []).forEach((r) => rules.push(r));
	}

	// Auto-add brand_name substitution for Frappe/ERPNext when set.
	if (config.brand_name) {
		rules.push({ find: "Frappe Framework", replace: config.brand_name, case_sensitive: true, whole_word: false, is_regex: false });
		rules.push({ find: "ERPNext", replace: config.brand_name, case_sensitive: true, whole_word: true, is_regex: false });
		rules.push({ find: "Frappe", replace: config.brand_name, case_sensitive: true, whole_word: true, is_regex: false });
	}
	return rules;
}

export function debug(config, ...args) {
	if (config && config.advanced && config.advanced.debug_logging) {
		// eslint-disable-next-line no-console
		console.debug("[white_label]", ...args);
	}
}
